export const sendMessageValidate = (formStaffMessage) => {

    const errors = {}

    if (formStaffMessage) {
        if (!formStaffMessage.fileID.trim()) {
            errors.fileID = "لطفا کد فایل را وارد کنید"
        } else {
            delete errors.fileID
        }

        if (!formStaffMessage.messageText.trim()) {
            errors.messageText = "لطفا متن پیام را وارد کنید"
        } else {
            delete errors.messageText
        }
    }

    return errors;

}